var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.5 37.0001C29.165 37.0001 37 29.165 37 19.5C37 9.83503 29.165 2 19.5 2C9.83502 2 2 9.83503 2 19.5C2 29.165 9.83502 37.0001 19.5 37.0001Z","stroke":"white","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M25.5 20.0002L15.5 25.5002V14.5001L25.5 20.0002Z","fill":"white","key":1})]);
}

PlayIcon.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
